import { createAction } from '@reduxjs/toolkit';

export const PROCESS_SEARCHED_RESULT_SET_TYPE = 'saga/processSearchedResultSet';
export const processSearchedResultSetAction = createAction(PROCESS_SEARCHED_RESULT_SET_TYPE);
